export const processDsCount = (state, action, data) => {
    return {
        data: data,
        countMapping: Object.fromEntries(new Map(data.map((obj) => [obj.id, obj.count]))),
    };
};
